import SweetAlert from "sweetalert2";
import "../styles/apparify-swal.css";

export const apparifySwalCustomClass = {
  container: "apparify-swal-container",
  popup: "apparify-swal-popup",
  icon: "apparify-swal-icon",
  title: "apparify-swal-title",
  htmlContainer: "apparify-swal-content",
  actions: "apparify-swal-actions",
  confirmButton: "apparify-swal-button apparify-swal-confirm",
  denyButton: "apparify-swal-button apparify-swal-deny",
  cancelButton: "apparify-swal-button apparify-swal-cancel",
  closeButton: "apparify-swal-close",
  input: "apparify-swal-input",
  validationMessage: "apparify-swal-validation",
  loader: "apparify-swal-loader",
  footer: "apparify-swal-footer",
  timerProgressBar: "apparify-swal-timer-progress",
};

export const apparifySwalDefaults = {
  buttonsStyling: false,
  customClass: apparifySwalCustomClass,
};

export const apparifySwalVariants = {
  archive: {
    customClass: {
      confirmButton: "apparify-swal-button apparify-swal-confirm apparify-swal-confirm-accent-subtle",
    },
  },
  logout: {
    iconColor: "rgba(239, 68, 68, 0.72)",
    customClass: {
      confirmButton: "apparify-swal-button apparify-swal-confirm apparify-swal-confirm-danger",
    },
  },
};

const logoutMessages = {
  business: "You will need to sign in again to use the Business Portal.",
  supplier: "You will need to sign in again to use the Supplier Portal.",
  admin: "You will need to sign in again to use the Admin Portal.",
  shopper: "Are you sure you want to logout?",
};

export function getApparifyLogoutDialogOptions(portal = "shopper") {
  return {
    icon: "warning",
    ...apparifySwalVariants.logout,
    title: "Log out?",
    html: logoutMessages[portal] || logoutMessages.shopper,
    showCancelButton: true,
    confirmButtonText: "Log out",
    cancelButtonText: "Cancel",
  };
}

function mergeCustomClass(customClass) {
  if (!customClass || typeof customClass !== "object") {
    return apparifySwalCustomClass;
  }

  return { ...apparifySwalCustomClass, ...customClass };
}

function withApparifyDesign(options = {}) {
  return {
    ...apparifySwalDefaults,
    ...options,
    customClass: mergeCustomClass(options.customClass),
  };
}

function fallbackArgsToParams(args) {
  if (args[0] && typeof args[0] === "object") return args[0];

  const params = {};
  ["title", "html", "icon"].forEach((name, index) => {
    if (args[index] !== undefined) params[name] = args[index];
  });
  return params;
}

const ApparifySwal = new Proxy(SweetAlert, {
  get(target, property, receiver) {
    if (property === "fire") {
      return (...args) => {
        const parsedOptions = typeof target.argsToParams === "function"
          ? target.argsToParams(args)
          : null;
        const options = parsedOptions && typeof parsedOptions === "object"
          ? parsedOptions
          : fallbackArgsToParams(args);
        return target.fire(withApparifyDesign(options));
      };
    }

    if (property === "mixin") {
      return (options = {}) => target.mixin(withApparifyDesign(options));
    }

    const value = Reflect.get(target, property, receiver);
    return typeof value === "function" ? value.bind(target) : value;
  },
});

export default ApparifySwal;
